import { memoize } from "lodash";
import * as Long from "long";
import { IdResource } from "../constants/IdResource";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingPackages = function () { return utilBalancing.getBalancing().Packages; };
export var selectPackageGoldCost = memoize(function (packageId) {
    var costs = selectPackageCostInfo(packageId);
    var sum = costs.reduce(function (acc, entry) { return (entry.resourceId === IdResource.Gold ? entry.amount + acc : acc); }, 0);
    return Long.fromValue(sum);
});
export var selectBalancingPackageById = memoize(function (id) { return selectBalancingPackages().get(id); });
export var selectBalancingPackagesByPartialName = memoize(function (partialName) {
    var packages = selectBalancingPackages();
    return Array.from(packages.values()).filter(function (element) { return element.name.indexOf(partialName) >= 0; });
});
export var selectPackageCostInfo = memoize(function (packageId) {
    var currentGift = selectBalancingPackageById(packageId);
    if (currentGift && currentGift.cost) {
        return currentGift.cost;
    }
    return [];
});
export var selectPackagesByType = memoize(function (type) {
    var packages = Array.from(selectBalancingPackages().values()) || [];
    return packages.filter(function (p) { return p.type === type; });
});
export var selectPackagesByRequiredOfferId = memoize(function (offerId) {
    var packages = Array.from(selectBalancingPackages().values()) || [];
    return packages
        .filter(function (p) { return p.requOfferId === offerId; })
        .sort(function (a, b) { return (a.requPlayerLevel || 0) - (b.requPlayerLevel || 0); });
});
export var selectPackageByNameType = function (name, type) {
    var packages = selectPackagesByType(type) || [];
    return packages.find(function (currentPackage) { return currentPackage.name === name; });
};
export var balancingPackagesMemoizedFunctions = [
    selectBalancingPackages,
    selectPackageGoldCost,
    selectBalancingPackageById,
    selectPackageCostInfo,
    selectPackagesByType,
    selectPackagesByRequiredOfferId,
    selectBalancingPackagesByPartialName,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingPackages.ts
// module id = 99
// module chunks = 3